<template>
  <div class="job-page">
    <header>
       <div class="normal-header-block">
        <div class="container">
          <div class="slogan-container">
            <h1>加入和鲸 在数据智能的时代躺赢</h1>
          </div>
        </div>
      </div>
    </header>
    <section>
      <div class="bg-block bg-job">
        <div class="job-container container">
          <div class="block-header job-header">
            <h2>加入我们</h2>
            <h3>Join Us</h3>
          </div>
          <div class="job-content">
            <div class="job-intro">
              <h3>在距离未来最近的地方加速迭代，一起引领下一个时代</h3>
            </div>
            <div class="job-flex-wrapper">
              <div class="job-col">
                <div class="job-card" v-for="(item, index) in leftData" :class="{'show': item.showDetail}" :key="index">
                  <div class="job-title-container" @click="item.showDetail = !item.showDetail">
                    <h3 class="job-title">{{item.title}}</h3>
                    <h3>{{item.location}}</h3>
                  </div>
                  <div class="job-detail-container">
                    <h5>岗位职责</h5>
                    <ol>
                      <li v-for="(duty, idx) in item.duties" :key="idx">{{duty}}
                      </li>
                    </ol>
                    <template v-if="item.capacities.length > 0">
                      <h5>任职要求</h5>
                      <ol>
                        <li v-for="(cap, idx) in item.capacities" :key="idx">{{cap}}
                        </li>
                      </ol>
                    </template>
                    <h5>简历投递</h5>
                    hr@heywhale.com
                  </div>
                </div>
              </div>
              <div class="job-col">
                <div class="job-card" v-for="(item, index) in rightData" :class="{'show': item.showDetail}" :key="index">
                  <div class="job-title-container" @click="item.showDetail = !item.showDetail">
                    <h3 class="job-title">{{item.title}}</h3>
                    <h3>{{item.location}}</h3>
                  </div>
                  <div class="job-detail-container">
                    <h5>岗位职责</h5>
                    <ol>
                      <li v-for="(duty, idx) in item.duties" :key="idx">{{duty}}
                      </li>
                    </ol>
                    <template v-if="item.capacities.length > 0">
                      <h5>任职要求</h5>
                      <ol>
                        <li v-for="(cap, idx) in item.capacities" :key="idx">{{cap}}
                        </li>
                      </ol>
                    </template>
                    <h5>简历投递</h5>
                    hr@heywhale.com
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import jobs from '../data/jobs.json';
export default {
  created() {
    this.jobs = jobs.map((r) => {
      r.showDetail = false;
      return r;
    });
  },
  data() {
    return {
      jobs: [],
      show: false
    };
  },
  computed: {
    leftData() {
      return this.jobs.slice(0, 5);
    },
    rightData() {
      return this.jobs.slice(5, 10);
    }
  }
};
</script>

<style lang="scss">
.job-page {
  .normal-header-block {
    background-image: url("../assets/banners/job.png");
  }
  .job-flex-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .job-col {
    width: 45%;
  }
  .job-intro {
    text-align: center;
    margin-bottom: 80px;
  }
  .job-card {
    background-color: #fff;
    margin-bottom: 32px;
    box-shadow: 0px 0px 23px 0px rgba(23, 128, 224, 0.12);
    overflow: hidden;
    max-height: 110px;
    transition: max-height .3s ease-in-out;
    &.show {
      max-height: 1000px;
    }
  }
  .job-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 48px;
    cursor: pointer;
    h3:nth-child(2) {
      color: #026EFF;
    }
  }
  .job-detail-container {
    border-top: solid 1px #DDDEE1;
    padding: 24px 48px;
    h5 {
      color: #026EFF;
    }
    ol {
      padding-left: 16px;
      margin-bottom: 24px;
    }
  }
  .job-title {
    font-weight: 500;
  }
  .job-title::before {
    content: " ";
    display: inline-block;
    width: 20px;
    height: 14px;
    margin-right: 12px;
    background-image: url('../assets/list-style-circle.svg');
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/job.vue